module.exports = {"130726100":"蔚州镇","130726101":"代王城镇","130726102":"西合营镇","130726103":"吉家庄镇","130726104":"白乐镇","130726105":"暖泉镇","130726106":"南留庄镇","130726107":"北水泉镇","130726108":"桃花镇","130726109":"阳眷镇","130726110":"宋家庄镇","130726200":"下宫村乡","130726202":"南杨庄乡","130726203":"柏树乡","130726204":"常宁乡","130726205":"涌泉庄乡","130726206":"杨庄窠乡","130726207":"南岭庄乡","130726208":"陈家洼乡","130726209":"黄梅乡","130726210":"白草村乡","130726211":"草沟堡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130726.json
// module id = 189
// module chunks = 0